<template>
	<div>
		<div class="head-box">
			<div class="but-box">
				<el-button type="success" icon='icon al-music' @click="$emit('musicSwitch')" circle></el-button>
				<el-button type="primary" icon='icon al-greet' @click="$emit('greetSwitch')" circle></el-button>
				<el-button type="info" icon='icon al-snow' @click="$emit('snowSwitch')" circle></el-button>
			</div>
			<div class="img-box">
				<img class='cycle-purple' src='../assets/home/cycle_purple.svg'>
				<img class='cycle-green' src='../assets/home/cycle_green.svg'>
				<img class='cycle-yellow' src='../assets/home/cycle_yellow.svg'>
				<img class='cycle-blue' src='../assets/home/cycle_blue.svg'>
				<img class='head-img' src='http://q.qlogo.cn/headimg_dl?dst_uin=2271697772&spec=640&img_type=jpg'>
			</div>
			<div class="info-box">
				<h1>ぜろ</h1>
				<h2>zero</h2>
			</div>
		</div>
		<div class="text-box">
			<h1>Liny</h1>
			<p>海の彼方には もう探さない</p>
			<p>輝く物は 何時も此処に</p>
			<p>私の中に 見つけられたから</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Home'
	}
</script>

<style>
	.head-box {
		margin: auto;
		width: 0;
		height: 400px;
	}

	.but-box>* {
		position: absolute;
		animation: open 0.8s ease-in-out;
		z-index: 1;
	}

	.but-box .icon {
		font-size: 30px;
	}

	.but-box>*:nth-child(1) {
		margin: -7px -118px;
	}

	.but-box>*:nth-child(2) {
		margin: 173px 172px;
	}

	.but-box>*:nth-child(3) {
		margin: 304px -178px;
	}

	.img-box>* {
		position: absolute;
	}

	.cycle-purple {
		width: 400px;
		margin: 0 -200px;
	}

	.cycle-green {
		width: 260px;
		margin: 70px -130px;
		animation: clockwise 1s linear infinite;
	}

	.cycle-yellow {
		width: 240px;
		margin: 80px -120px;
		animation: clockwise 1s linear infinite reverse;
	}

	.cycle-blue {
		width: 220px;
		margin: 90px -110px;
		animation: clockwise 1s linear infinite;
	}

	.head-img {
		width: 200px;
		margin: 97px -103px;
		border-radius: 50%;
		border: 3px solid pink;
		animation: hide 0.1s, show 0.8s 0.1s ease-in-out, flash 1.5s ease-in-out infinite alternate;
	}

	.info-box {
		width: 200px;
		height: 200px;
		color: #ffffff;
		opacity: 0;
		text-align: center;
		margin: 100px -100px;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.6);
		position: absolute;
		transition: all 1s ease-in-out;
	}

	.info-box:hover {
		opacity: 1;
	}

	.info-box h1 {
		margin: 50px 15px 0;
		font-size: 70px;
		line-height: 80px;
		font-weight: lighter;
		border-bottom: 1px solid #ffffff;
	}

	.info-box h2 {
		margin: 0;
		font-style: italic;
		letter-spacing: 5px;
		font-size: 25px;
	}

	.text-box {
		color: #ffffff;
		text-align: center;
		width: 320px;
		margin: 0 auto;
	}

	.text-box>* {
		font-weight: lighter;
	}

	.text-box>h1 {
		margin: 15px auto 20px;
		font-size: 45px;
		line-height: 55px;
	}

	.text-box>p {
		margin: 6px;
		font-size: 18px;
		line-height: 26px;
		cursor: pointer;
		transition: all 0.5s;
	}

	.text-box>p:nth-of-type(1) {
		animation: hide 1s, show 0.7s 1s ease-in;
	}

	.text-box>p:nth-of-type(2) {
		animation: hide 2s, show 0.7s 2s ease-in;
	}

	.text-box>p:nth-of-type(3) {
		animation: hide 3s, show 0.7s 3s ease-in;
	}

	.text-box>p:hover {
		font-size: 22px;
	}

	@media screen and (max-width: 700px) {
		.head-box {
			margin: auto;
			width: 0;
			height: 330px;
		}

		.but-box,
		.cycle-purple {
			display: none;
		}
	}

	@keyframes open {
		from {
			opacity: 0;
			margin: 180px -52px;
		}
	}

	@keyframes hide {
		from,
		to {
			opacity: 0;
		}
	}

	@keyframes show {
		from {
			opacity: 0;
		}
	}

	@keyframes flash {
		from {
			box-shadow: 0 0 1px #fff,
				0 0 2px #fff,
				0 0 3px #fff,
				0 0 4px #fff;
		}

		to {
			box-shadow: 0 0 5px #fff,
				0 0 10px #fff,
				0 0 15px #fff,
				0 0 20px #fff;
		}
	}

	@keyframes clockwise {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}
</style>
